import { useEffect, useState } from 'react';
import { getProjectGraphApi } from '../redux/project/apiRoute';

const useGetProjectCount = (moduleType, id, filterType, dateFilter) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        setLoading(true);
        let params = new URLSearchParams();
        id && params.append('employeeId', id);
        filterType && params.append('filterType', filterType);
        dateFilter && params.append('startRange', dateFilter?.[0]);
        dateFilter && params.append('endRange', dateFilter?.[1]);
        params.append('moduleType', moduleType);

        let res = await getProjectGraphApi(params);
        if (res?.statusCode === 200) {
          const data = Object?.entries(res?.data || {})?.map(([key, value]) => ({
            name: key.charAt(0).toUpperCase() + key.slice(1),
            count: value
          }));
          setOptions(data);
        } else {
          setError(res?.message || 'Something went wrong');
        }
      } catch (error) {
        setError(error?.message || 'Something went wrong');
      } finally {
        setLoading(false);
      }
    };
    fetchCount();
  }, [id, filterType, dateFilter]);

  return { options, loading, error };
};

export default useGetProjectCount;
